import { render, staticRenderFns } from "./PlaySoundTest.vue?vue&type=template&id=5510e25e&scoped=true&"
import script from "./PlaySoundTest.vue?vue&type=script&lang=js&"
export * from "./PlaySoundTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5510e25e",
  null
  
)

export default component.exports